import { sortBy } from 'lodash';
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { DEFAULT_MEETINGS_ORDER_BY } from './constants';

/**
 * Retrieves meetings for a given event, optionally filtered and sorted.
 * @param {number} eventId - The ID of the event.
 * @param {Object} options - An optional object containing filter, sortBy and count.
 * @param {function} options.filter - A function that filters the meetings array.
 * @param {function} options.sortBy - A function that sorts the meetings array.
 * @param {number} options.count - The maximum number of meetings to return.
 * @return {Array} - An array of meetings for the given event, optionally filtered and sorted.
 */
export function useMeetings(eventId, { count, filter, sortBy: sortFunction = DEFAULT_MEETINGS_ORDER_BY } = {}) {
    const meetingsSelector = useCallback((state) => state.events[eventId]?.meetings.all, [eventId]),
        meetings = useSelector((state) => state.events[eventId]?.meetings.all);

    return useMemo(() => {
        let result = meetings ?? [];

        if (filter) result = result.filter(filter);
        if (sortFunction) result = sortBy(result, sortFunction);
        if (count) result = result.slice(0, count);

        return result;
    }, [eventId, meetings, count, filter, sortFunction]);
}
